/*
** TO IMPLEMENT:
**[alias]: the product alias
**[image]: the last number in the image path
**[image-size] (optional): the size of the image (default is 200 when not specified)
**p: the product's name
		
<product-card alias="152528" image="542061" image-size="500">
	<p>Ultra Plush Blanket</p>
</product-card> 
*/

import { productImagePath } from "../localized.js";

class ProductCard extends HTMLElement {
	constructor() {
        super();
        
		this.tracking = document.getElementById("trackingID")?.value;
        this.prodName = this.querySelector("p")?.textContent || "4imprint Product";
		this.imageSize = this.getAttribute("image-size") || "200";
	}
	
	get alias(){
		return this.getAttribute("alias");
	}
	
	set alias(value){
		this.setAttribute("alias", value);
	}
		
	get image(){
		return this.getAttribute("image");
	}
	
	set image(value){
		this.setAttribute("image", value);
	}

	get imageSize(){
		return this.getAttribute("image-size") || "200";
	}

	set imageSize(value){
		this.setAttribute("image-size", value);
	}
	
	connectedCallback() {		
		const style = document.createElement("style");
		style.textContent = `
			:host > div { 
				border: var(--borderSolidThin) var(--ltGray); 
				margin-bottom: 1.25rem;
				-webkit-box-shadow: rgba(17, 17, 26, 0.1) 0 0 0.5rem;
				-moz-box-shadow: rgba(17, 17, 26, 0.1) 0 0 0.5rem;
				box-shadow: rgba(17, 17, 26, 0.1) 0 0 0.5rem;
			}
			picture { 
				display: block; 
				margin: 0.625rem 0.625rem 1.25rem 0.625rem; 
				text-align: center;
			}
			h3 { 
				color: var(--darkestGray); 
				font-size: 1rem; 
				font-weight: 600;
				margin: 0 0.625rem;
			}
			p { 
				font-size: 1rem; 
				color: var(--dkGray); 
				margin: 0.313rem 0.625rem;
			}
			link-element { display: block; }
			.visually-hidden{
				position: absolute !important;
				clip: rect(0.0625rem, 0.0625rem, 0.0625rem, 0.0625rem);
				padding: 0 !important;
				border: 0 !important;
				height: 0.0625rem !important;
				width: 0.0625rem !important;
				overflow: hidden;
			}
			img	{ max-width: 100%; height: auto;}
			
		`;
		
		const productCard = document.createElement("div");
		const html = `
			<picture>
				<source srcset="${productImagePath}/${this.imageSize}/${this.image}.webp" type="image/webp">
				<source srcset="${productImagePath}/${this.imageSize}/${this.image}.jpg" type="image/jpeg"> 
				<img width="${this.imageSize}" height="${this.imageSize}" src="${productImagePath}/${this.imageSize}/${this.image}.jpg" alt="${this.prodName}">
			</picture>
			<h3>${this.prodName}</h3>
			<p>Item #${this.alias}</p>
			<link-element color="blue" link="/product/${this.alias}${this.tracking}" padding="10">
				<span slot>Shop <span class="visually-hidden"> the ${this.prodName}</span> Now</span>
			</link-element>
		`;
		productCard.innerHTML = html;
		
		this._shadowRoot = this.attachShadow({ mode: "open" });
		this._shadowRoot.appendChild(style);
        this._shadowRoot.appendChild(productCard);
	}
	
	attributeChangedCallback(attrName, oldValue, newValue) {
		if (newValue !== oldValue) {
			switch (attrName) {
				case 'alias':
				case 'image':
				case 'image-size':
					this[attrName] = this.getAttribute(attrName);
					break;
			}
		}
	}
}

customElements.define('product-card', ProductCard);